import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { addSpaceEvery4, decimal, GetStatus, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import { useCallApi } from "api/apiHooks"
import { useModal } from "context/ModalContext"
import { PagesFormTitle } from "components/Cards"

export default function CustomerCardForm(){
    const navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBankList, fetchCardVendorList, fetchInsertCustomerCard, fetchUpdateCustomerCard, fetchDeleteCustomerCard, fetchCustomerList, fetchCustomerCardById } = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerCardId = queryString.get("customerCardId")

    const [customerName, setCustomerName] = useState(EmptyString)
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [cardVendorId, setCardVendorId] = useState(EmptyString)
    const [cardVendorOptions, setCardVendorOptions] = useState([])
    const [customerId, setCustomerId] = useState(EmptyString)
    const [customerOptions, setCustomerOptions] = useState(EmptyString)
    const [expiredMonth, setExpiredMonth] = useState(EmptyString)
    const [expiredYear, setExpiredYear] = useState(EmptyString)
    const [vcc, setVcc] = useState(EmptyString)
    const [mdr, setMdr] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [errorCardNumber, setErrorCardNumber] = useState(false)
    const [errorBankId, setErrorBankId] = useState(false)
    const [errorCardVendorId, setErrorCardVendorId] = useState(false)
    const [errorCustomerId, setErrorCustomerId] = useState(false)
    const [errorExpiredMonth, setErrorExpiredMonth] = useState(false)
    const [errorExpiredYear, setErrorExpiredYear] = useState(false)
    const [errorVcc, setErrorVcc] = useState(false)
    const [errorMdr, setErrorMdr] = useState(false)
    
    const cardNumberChange = (e) => { setCardNumber(addSpaceEvery4(removeNonNumeric(e.target.value))) }
    const bankIdChange = (e) => { setBankId(e.value) }
    const cardVendorIdChange = (e) => { setCardVendorId(e.value) }
    const customerIdChange = (e) => { setCustomerId(e) }
    const expiredMonthChange = (e) => { setExpiredMonth(removeNonNumeric(e.target.value)) }
    const expiredYearChange = (e) => { setExpiredYear(removeNonNumeric(e.target.value)) }
    const vccChange = (e) => { setVcc(removeNonNumeric(e.target.value)) }
    const mdrChange = (e) => { setMdr(decimal(e.target.value)) }

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    if (formType === FormTypeAdd){
                        const res = await fetchInsertCustomerCard(
                            customerId.value,
                            cardNumber.replace(/\s+/g, ""),
                            bankId,
                            cardVendorId,
                            expiredMonth,
                            expiredYear,
                            vcc,
                            mdr
                        )
                        if (!res) return
                    }else{
                        const res = await fetchUpdateCustomerCard(
                            paramCustomerCardId,
                            customerId.value,
                            cardNumber.replace(/\s+/g, ""),
                            bankId,
                            cardVendorId,
                            expiredMonth,
                            expiredYear,
                            vcc,
                            mdr
                        )
                        if (!res) return
                    }
                    
                    showSuccess({
                        onSuccess: () => {
                            navigate('/customer-card')
                        }
                    })
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                const res = await fetchDeleteCustomerCard(
                    paramCustomerCardId, status
                )
                if (!res) return
                
                showSuccess({
                    onSuccess: () => {
                        navigate('/customer-card')
                    }
                })
            } finally {
                hideLoading()
            }
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        if (customerId.value === EmptyString || customerId === EmptyString){
            errorCount++
            setErrorCustomerId(true)
        }else{
            setErrorCustomerId(false)
        }

        if (cardNumber === EmptyString){
            errorCount++
            setErrorCardNumber(true)
        }else{
            setErrorCardNumber(false)
        }

        if (bankId === EmptyString){
            errorCount++
            setErrorBankId(true)
        }else{
            setErrorBankId(false)
        }

        if (cardVendorId === EmptyString){
            errorCount++
            setErrorCardVendorId(true)
        }else{
            setErrorCardVendorId(false)
        }

        if (mdr === EmptyString){
            errorCount++
            setErrorMdr(true)
        }else{
            setErrorMdr(false)
        }

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    useEffect(() => {
        const firstLoad = async () => {
            try {
                showLoading()

                // Get Bank
                const res = await fetchBankList('', '', '1', 10000, 0)

                if (!res) return

                let data = res.data.listData
                let tempArray = []

                tempArray.push({ label: "All", value: "" })

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
                }

                setBankOptions(tempArray)
                setBankId(tempArray[0].value)

                // Get Vendor
                const res2 = await fetchCardVendorList('', '1', 10000, 0)

                if (!res2) return

                let data2 = res2.data.listData
                let tempArray2 = []

                tempArray2.push({ label: "Pilih Vendor", value: "" })

                for (let i = 0; i < data2.length; i++){
                    tempArray2.push({ label: data2[i].cardVendorName, value: String(data2[i].cardVendorId) })
                }

                setCardVendorOptions(tempArray2)
                setCardVendorId(tempArray2[0].value)

                // Get Customer
                const res3 = await fetchCustomerList('', '', '', '1', 10000, 0)

                if (!res3) return

                let data3 = res3.data.listData
                let tempArray3 = []

                tempArray3.push({ label: "Pilih Pelanggan", value: "" })

                for (let i = 0; i < data3.length; i++){
                    tempArray3.push({ label: data3[i].customerName.toUpperCase(), value: String(data3[i].customerId) })
                }

                setCustomerOptions(tempArray3)
                setCustomerId(tempArray3[0].value)

                // Get Customer (If Form Type is Edit)
                if (formType ===  FormTypeEdit){
                    const res4 = await fetchCustomerCardById(paramCustomerCardId)

                    if (!res4) return

                    let data = res4.data

                    setCustomerId({label: data.customerName, value: String(data.customerId)})
                    setCardNumber(data.cardNumber)
                    setBankId(String(data.bankId))
                    setCardVendorId(String(data.cardVendorId))
                    setExpiredMonth(data.expiredMonth)
                    setExpiredYear(data.expiredYear)
                    setVcc(data.vcc)
                    setMdr(data.mdr)
                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                }
            } finally {
                hideLoading()
            }
            
        }

        firstLoad()
    }, [])

    return (
        <div className="flex flex-col gap-2">
            <PagesFormTitle
                title='Detail Kartu Pelanggan'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col gap-3">
                {/* Customer */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Customer</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <Select options={customerOptions} value={customerId} onChange={customerIdChange} placeholder={"Select Customer"} 
                                    // isDisabled={formType === FormTypeEdit ? true : false} 
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCustomerId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Customer is required!</span>
                    </div>
                </div>

                {/* Card Number */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Card Number</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={cardNumber} onChange={cardNumberChange} maxLength={20} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCardNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Card Number is required!</span>
                    </div>
                </div>

                {/* Bank */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Bank</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <Dropdown options={bankOptions} value={bankId} onChange={bankIdChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorBankId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank is required!</span>
                    </div>
                </div>

                {/* Card Vendor */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Card Vendor</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <Dropdown options={cardVendorOptions} value={cardVendorId} onChange={cardVendorIdChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCardVendorId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Card Vendor is required!</span>
                    </div>
                </div>

                {/* Expired */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Expired</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="flex gap-4 w-full sm:w-72">
                                <input className="input" value={expiredMonth} onChange={expiredMonthChange} maxLength={2} />
                                <input className="input" value={expiredYear} onChange={expiredYearChange} maxLength={2} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorExpiredMonth ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Expired is required!</span>
                    </div>
                </div>

                {/* VCC */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Kode VCC</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="flex gap-4 w-full sm:w-72">
                                <input className="input" value={vcc} onChange={vccChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorVcc ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">VCC is required!</span>
                    </div>
                </div>

                {/* MDR */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>MDR</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="flex gap-4 w-full sm:w-72">
                                <input className="input" value={mdr} onChange={mdrChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorMdr ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">MDR is required!</span>
                    </div>
                </div>
            </div>
                
            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>
        </div>
    )
}